import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { recordPageView } from '@/lib/analytics';
import { useAuth } from '@/contexts/auth/useAuth';

export function PageTracker() {
  const location = useLocation();
  const { user } = useAuth();
  const lastSentPath = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (lastSentPath.current === path) return;
    lastSentPath.current = path;

    recordPageView(path, user?.id ?? null);
  }, [location.pathname, location.search, user?.id]);

  return null;
}
